import React, { useState, useEffect } from "react";
import TrackListModal from "../modals/TrackListModal";
import TrackCategoryModal from "../modals/TrackCategoryModal";
import AltCategoryModal from "../modals/AltCategoryModal";
import TrackByBookModal from "../modals/TrackByBookModal";
import TrackByProfileModal from "../modals/TrackByProfileModal";
import LimitsModal from "../limits/LimitsModal";
import SystemPreferencesModal from "../modals/SystemPreferencesModal";
import PossiblePastPostModal from "../tickets/PossiblePastPostModal";
import ManuallyScoreTicketsModal from "../tickets/ManuallyScoreTicketsModal";
import PayRebatesModal from "../tickets/PayRebatesModal";
import dayjs from "dayjs";
import NewRaceModal from "../modals/NewRaceModal";
import ErrorCodes from "../../constants/ErrorCodes";
import OpenTicketsModal from "../tickets/OpenTicketsModal";
import { useSelectFunctions, useSpecialFunctions } from "../../functions";
import Rights from "../../constants/Rights";
import { MDBTooltip } from "mdb-react-ui-kit";
import MyPackagesModal from "../modals/MyPackagesModal";

const Header = ({
  logout,
  data,
  gameProviders,
  trackCategory,
  setTrackCategory,
  getTrackCategory,
  trackCategoryCbx,
  profiles,
  getProfiles,
  limitSetList,
  getLimitSetList,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  setSelectOption,
  getActiveTracks,
  countries,
  allStates,
  sessionNoLongerExists,
  setSessionNoLongerExists,
  publicIP,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  voidTickets,
  callTicketVoidListFrom,
  scoreTickets,
  userRightsList,
  systemPreferences,
  setSystemPreferences,
  handleGetSystemPreferencesRacing,
}) => {
  const [trackList, setTrackList] = useState([]);
  const [altCategories, setAltCategories] = useState([]);
  const [books, setBooks] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(-1);
  const [idFirstBook, setIdFirstBook] = useState("");
  const [tracksByBooks, setTracksByBooks] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [changeData, setChangeData] = useState(false);
  const [bookOptionSelected, setBookOptionSelected] = useState("");
  const [tracksByProfile, setTracksByProfile] = useState([]);
  const [idFirstProfile, setIdFirstProfile] = useState("");
  const [profileOptionSelected, setProfileOptionSelected] = useState("");
  const [categoryOptionSelected, setCategoryOptionSelected] = useState("");
  const [idLimitSet, setIdLimitSet] = useState("");
  const [limitSetBetTypes, setLimitSetBetTypes] = useState([]);
  const [limitSetInfo, setLimitSetInfo] = useState({
    LimitSetName: "",
    ParlayMaxSize: "",
    MaxRaceWin: "",
    MaxRaceWinType: 0,
  });
  const [betTypeOptionSelected, setBetTypeOptionSelected] = useState(0);
  const [lastChanges, setLastChanges] = useState({
    FilterValue1: "",
    FilterValue2: 0,
    FilterValue3: 0,
    IdSport: "",
    TableName: "",
  });
  const [getLastChangesInfo, setGetLastChangesInfo] = useState(false);
  const [lastChangesInfo, setLastChangesInfo] = useState([]);
  const [fieldChangesInfo, setFieldChangesInfo] = useState([]);
  const [trackOptionSelected, setTrackOptionSelected] = useState("");
  const [trackName, setTrackName] = useState("");
  const [profileName, setProfileName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [betTypeName, setBetTypeName] = useState("Win");
  const [bookName, setBookName] = useState("");
  const [shouldFocusLastTrack, setShouldFocusLastTrack] = useState(false);
  const [addTrack, setAddTrack] = useState(false);
  const [pastPostTicketsByDate, setPastPostTicketsByDate] = useState([]);
  const [datePastPostFilter, setDatePastPostFilter] = useState(new Date());
  const [manuallyScoreTickets, setManuallyScoreTickets] = useState([]);
  const [openNewAltCategoryModal, setOpenNewAltCategoryModal] = useState(false);
  const [openByBooksModal, setOpenByBooksModal] = useState(false);
  const [openByProfileModal, setOpenByProfileModal] = useState(false);
  const [openNewRaceModal, setOpenNewRaceModal] = useState(false);
  const [shouldFocusLast, setShouldFocusLast] = useState(false);
  const [openTicketsByPeriodOffTime, setOpenTicketsByPeriodOffTime] = useState(
    [],
  );
  const [dateFromOpenTickets, setDateFromOpenTickets] = useState(new Date());
  const [dateToOpenTickets, setDateToOpenTickets] = useState(new Date());
  const [isPastPostTicketsModalOpen, setIsPastPostTicketsModalOpen] =
    useState(false);
  const [loadingTracks, setLoadingTracks] = useState(true);
  const {
    getTracksList,
    getTrackAltCategory,
    getBooksList,
    getTracksByBook,
    getTracksByProfileList,
    getLimitSetId,
    getLimitsSet,
    getLastChange,
    getChangesByField,
    getPastPostTicketsByDateList,
    getManualScoreTickets,
    getOpenBetsByPeriodOfTime,
    getTrackListEnabled,
  } = useSelectFunctions();

  const { checkHasUpgrade } = useSpecialFunctions();
  const [tracksListCbx, setTracksListCbx] = useState([]);
  const [showPackagesModal, setShowPackagesModal] = useState(false);
  const [hasUpgrade, setHasUpgrade] = useState(true);

  //Get Tracks function from Track Tab
  const getTracks = async (newTrack) => {
    const res = await getTracksList(
      { IDProvider: -1, TrackType: -1, Name: "", Enabled: "All" },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      setLoadingTracks(false);
      return;
    } else {
      setTrackList(res.Tracks);
      if (newTrack) {
        setAddTrack(true);
      }
      setLoadingTracks(false);
    }
  };

  // This useEffect function is used to shade the last inserted row of tracks after loading the tracks.
  useEffect(() => {
    if (addTrack) {
      setShouldFocusLastTrack(true);
      setAddTrack(false);
    }
  }, [trackList]);

  //Get Alt Track Category function
  const getAltCategory = async (newAltCat) => {
    const res = await getTrackAltCategory(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setAltCategories(res.TrackAltCategoryList);
      if (newAltCat) {
        setShouldFocusLast(true);
      }
    }
  };

  // Get Books function
  const getBooks = async () => {
    const res = await getBooksList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setBooks(res.Books);
    }
  };

  // Get Tracks by Books function
  const getTracksByBooks = async (IDBook) => {
    const res = await getTracksByBook(
      {
        IDBook: IDBook,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setTracksByBooks(res.TrackByBookList);
      setIdFirstBook(IDBook);
    }
  };

  // Get Tracks by Profile function
  const getTracksByProfile = async (IDProfile) => {
    const res = await getTracksByProfileList(
      {
        IDProfile: IDProfile,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setTracksByProfile(res.ProfilesTrackList);
      setIdFirstProfile(IDProfile);
    }
  };

  // Get Limit Set function
  const getLimitSet = async (limitSetID) => {
    const res = await getLimitsSet(
      {
        LimitSetID: limitSetID,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setLimitSetBetTypes(res.LimitSetBetType);
      setLimitSetInfo(
        ...limitSetList.filter((item) => item.LimitSetID === limitSetID),
      );
    }
  };

  // Get Limit Set ID function
  const getLimitSetID = async () => {
    const res = await getLimitSetId(
      {
        ProfileID: profileOptionSelected,
        IDTrackCategory: categoryOptionSelected,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setIdLimitSet(res.LimitSetID);
      if (res.LimitSetID !== 0) {
        setLimitSetInfo(
          ...limitSetList.filter((item) => item.LimitSetID === res.LimitSetID),
        );
      } else {
        setLimitSetBetTypes([]);
        setLimitSetInfo({
          LimitSetName: "",
          ParlayMaxSize: "",
          MaxRaceWin: "",
          MaxRaceWinType: 0,
        });
      }
    }
  };

  useEffect(() => {
    if (!systemPreferences.TrackPackage) return;

    const hasUpgradeFlag = checkHasUpgrade(systemPreferences.TrackPackage);

    const today = new Date().toDateString();
    const lastOpened = localStorage.getItem("packagesModalOpenedDate");

    if (hasUpgradeFlag && lastOpened !== today) {
      setHasUpgrade(true);
    } else {
      setHasUpgrade(false);
    }
  }, [systemPreferences.TrackPackage]);

  // This hook is used to set the first position of the list of Tracks in the trackOptionSelected state to be used by default in the Track Table.
  useEffect(() => {
    if (trackList.length !== 0 && !refresh && !changeData) {
      setTrackOptionSelected(trackList[0].TrackID);
      setTrackName(trackList[0].TrackName);
    }
  }, [trackList]);

  // This hook is used to set the first position of the list of books in the IdFirstBook state to be used by default in the combo box.
  useEffect(() => {
    if (books.length !== 0 && !refresh) {
      setIdFirstBook(books[0].IDBook);
      getTracksByBooks(books[0].IDBook);
      setBookOptionSelected(books[0].IDBook);
      setBookName(books[0].Description);
    }
  }, [books]);

  // This hook is used to set the first position of the list of profiles in the IdFirstProfile state to be used by default in the combo box.
  useEffect(() => {
    if (profiles.length !== 0 && !refresh) {
      setIdFirstProfile(profiles[0].ProfileID);
      getTracksByProfile(profiles[0].ProfileID);
      setProfileOptionSelected(profiles[0].ProfileID);
      setProfileName(profiles[0].ProfileName);
    }
  }, [profiles]);

  // This hook is used to set the first position of the list of profiles and category in the IdFirstProfileLimit, IdFirstCategoryLimit state to be used by default in the tables.
  useEffect(() => {
    if (trackCategory.length !== 0 && !refresh) {
      setCategoryOptionSelected(trackCategory[0].IDTrackCategory);
      setCategoryName(trackCategory[0].Description);
    }
  }, [trackCategory]);

  // This function is called when user clicks on option Alt Category of the Tracks option in the navbar
  const openAltCategoryModal = () => {
    getAltCategory(false);
    getProfiles();
    setOpenNewAltCategoryModal(true);
  };

  // This function is called when user clicks on option By Book of the Tracks option in the navbar
  const openByBookModal = () => {
    getBooks();
    setOpenByBooksModal(true);
  };

  // This function is called when user clicks on option Profiles of the Tracks option in the navbar
  const openByProfilesModal = () => {
    getProfiles();
    setOpenByProfileModal(true);
  };

  // This hook executes the getLimitSetID function if there is a category and profile selected
  useEffect(() => {
    if (categoryOptionSelected && profileOptionSelected) {
      getLimitSetID();
    }
  }, [profileOptionSelected, categoryOptionSelected]);

  // This hook executes the getLimitSet function if a LimitSet is selected
  useEffect(() => {
    if (idLimitSet) {
      getLimitSet(idLimitSet);
    }
  }, [idLimitSet]);

  // This function is called when user clicks on option Limits option in the navbar
  const openLimitsModal = () => {
    getProfiles();
    getTrackCategory();
    getLimitSetList();
    if (categoryOptionSelected && profileOptionSelected) {
      getLimitSetID();
    }
  };

  // This function is executed when the user clicks on the Last changes button of the different modals that require it.
  // (Tracks, Tracks by Books, Tracks by Profile)
  const openLastChanges = (
    changeType,
    param1,
    param2,
    headerName1,
    headerName2,
  ) => {
    setLastChanges({
      FilterValue1: param1,
      FilterValue2: param2,
      FilterValue3: 0,
      IdSport: "",
      TableName: changeType,
      HeaderName1: headerName1,
      HeaderName2: headerName2,
    });

    setGetLastChangesInfo(true);
  };

  // This useEffect is executed when the lastChanges status changes.
  // Is executed by clicking on the buttons: (Category Changes, LimitSet Changes and BetType Changes)
  useEffect(() => {
    if (getLastChangesInfo) {
      const fetchData = async () => {
        const res = await getLastChange(
          { ...lastChanges },
          data.LogonSessionID,
        );

        if (res?.error) {
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          }
          return;
        } else {
          let parsed = [];

          if (Array.isArray(res)) {
            parsed = res
              .map((item) => {
                if (typeof item === "string") {
                  try {
                    return JSON.parse(item);
                  } catch {
                    return null;
                  }
                } else {
                  return item;
                }
              })
              .filter(Boolean);

            setLastChangesInfo(parsed);
          } else {
            setLastChangesInfo([]);
          }
        }

        setGetLastChangesInfo(false);
      };

      fetchData();
    }
  }, [getLastChangesInfo]);

  // This function is executed when user clicks on the tab Field Changes
  const getFieldChanges = async (fieldName) => {
    const res = await getChangesByField(
      {
        ...lastChanges,
        FieldName: fieldName,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      let parsed = [];

      if (Array.isArray(res)) {
        parsed = res
          .map((item) => {
            if (typeof item === "string") {
              try {
                return JSON.parse(item);
              } catch {
                return null;
              }
            } else {
              return item;
            }
          })
          .filter(Boolean);

        setFieldChangesInfo(parsed);
      } else {
        setLastChangesInfo([]);
      }
    }
  };

  // This function is executed when user clicks on the tab Possible Past Post Tickets
  const getPastPostTicketsByDate = async () => {
    const res = await getPastPostTicketsByDateList(
      {
        RaceDate: dayjs(datePastPostFilter).format("MM/DD/YYYY"),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setPastPostTicketsByDate(res.PastPostByDateList);
    }
  };

  // This function is executed when user clicks on the tab Possible Past Post Tickets
  const getOpenTicketsByPeriodOffTime = async () => {
    const res = await getOpenBetsByPeriodOfTime(
      {
        PlacedDateTimeFrom: dayjs(dateFromOpenTickets).format("MM/DD/YYYY"),
        PlacedDateTimeTo: dayjs(dateToOpenTickets).format("MM/DD/YYYY"),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setOpenTicketsByPeriodOffTime(res.OpenBetsList);
    }
  };

  // This function is executed when user clicks on the tab Manually Score Tickets
  const getManuallyScoreTickets = async () => {
    const res = await getManualScoreTickets(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setManuallyScoreTickets(res.ManualScoreQList);
    }
  };

  const hasTrackPermissions = () =>
    userRightsList.some((right) =>
      [
        Rights.FRM_TRACKS,
        Rights.FRM_TRACK_CATEGORY,
        Rights.FRM_PROFILE_TRACKS,
        Rights.FRM_TRACKS_BY_BOOK,
      ].includes(right.FormName),
    );

  const hasTicketsPermissions = () =>
    userRightsList.some((right) =>
      [
        Rights.FRM_PAST_POST,
        Rights.FRM_OPEN_TICKETS,
        Rights.FRM_PAY_REBATES,
      ].includes(right.FormName),
    );

  const getTracksListCbx = async (providerID) => {
    const res = await getTrackListEnabled(
      {
        ProviderID: providerID,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setTracksListCbx(res.TrackList);
      return res.TrackList;
    }
  };

  useEffect(() => {
    const today = new Date().toDateString();
    const lastOpened = localStorage.getItem("packagesModalOpenedDate");

    if (lastOpened === today) {
      setHasUpgrade(false);
    } else {
      setHasUpgrade(true);
    }
  }, []);

  return (
    <>
      <TrackListModal
        trackList={trackList}
        setTrackList={setTrackList}
        gameProviders={gameProviders}
        trackCategoryCbx={trackCategoryCbx}
        data={data}
        getTracks={getTracks}
        lastChanges={lastChanges}
        setLastChanges={setLastChanges}
        lastChangesInfo={lastChangesInfo}
        setLastChangesInfo={setLastChangesInfo}
        fieldChangesInfo={fieldChangesInfo}
        setFieldChangesInfo={setFieldChangesInfo}
        getFieldChanges={getFieldChanges}
        openLastChanges={openLastChanges}
        trackOptionSelected={trackOptionSelected}
        setTrackOptionSelected={setTrackOptionSelected}
        trackName={trackName}
        setTrackName={setTrackName}
        setRefresh={setRefresh}
        setChangeData={setChangeData}
        shouldFocusLastTrack={shouldFocusLastTrack}
        setShouldFocusLastTrack={setShouldFocusLastTrack}
        countries={countries}
        allStates={allStates}
        setSessionNoLongerExists={setSessionNoLongerExists}
        publicIP={publicIP}
        loadingTracks={loadingTracks}
        systemPreferences={systemPreferences}
      />

      <TrackCategoryModal
        trackCategory={trackCategory}
        setTrackCategory={setTrackCategory}
        data={data}
        getTrackCategory={getTrackCategory}
        sessionNoLongerExists={sessionNoLongerExists}
        setSessionNoLongerExists={setSessionNoLongerExists}
      />

      {openNewAltCategoryModal && (
        <AltCategoryModal
          data={data}
          trackCategoryCbx={trackCategoryCbx}
          altCategories={altCategories}
          setAltCategories={setAltCategories}
          getAltCategory={getAltCategory}
          profiles={profiles}
          gameProviders={gameProviders}
          shouldFocusLast={shouldFocusLast}
          setShouldFocusLast={setShouldFocusLast}
          setSessionNoLongerExists={setSessionNoLongerExists}
          openNewAltCategoryModal={openNewAltCategoryModal}
          setOpenNewAltCategoryModal={setOpenNewAltCategoryModal}
          getTracksListCbx={getTracksListCbx}
          tracksListCbx={tracksListCbx}
        />
      )}
      {openByBooksModal && (
        <TrackByBookModal
          data={data}
          books={books}
          gameProviders={gameProviders}
          setSelectedProvider={setSelectedProvider}
          selectedProvider={selectedProvider}
          getTracksByBooks={getTracksByBooks}
          idFirstBook={idFirstBook}
          tracksByBooks={tracksByBooks}
          setTracksByBooks={setTracksByBooks}
          getBooks={getBooks}
          setRefresh={setRefresh}
          bookOptionSelected={bookOptionSelected}
          setBookOptionSelected={setBookOptionSelected}
          lastChanges={lastChanges}
          setLastChanges={setLastChanges}
          lastChangesInfo={lastChangesInfo}
          setLastChangesInfo={setLastChangesInfo}
          fieldChangesInfo={fieldChangesInfo}
          setFieldChangesInfo={setFieldChangesInfo}
          getFieldChanges={getFieldChanges}
          openLastChanges={openLastChanges}
          bookName={bookName}
          setBookName={setBookName}
          sessionNoLongerExists={sessionNoLongerExists}
          setSessionNoLongerExists={setSessionNoLongerExists}
          publicIP={publicIP}
          setOpenByBooksModal={setOpenByBooksModal}
          getTracksListCbx={getTracksListCbx}
          tracksListCbx={tracksListCbx}
          setTracksListCbx={setTracksListCbx}
        />
      )}

      {openByProfileModal && (
        <TrackByProfileModal
          data={data}
          profiles={profiles}
          gameProviders={gameProviders}
          setSelectedProvider={setSelectedProvider}
          selectedProvider={selectedProvider}
          getTracksByProfile={getTracksByProfile}
          idFirstProfile={idFirstProfile}
          tracksByProfile={tracksByProfile}
          setTracksByProfile={setTracksByProfile}
          getProfiles={getProfiles}
          setRefresh={setRefresh}
          profileOptionSelected={profileOptionSelected}
          setProfileOptionSelected={setProfileOptionSelected}
          lastChanges={lastChanges}
          setLastChanges={setLastChanges}
          lastChangesInfo={lastChangesInfo}
          setLastChangesInfo={setLastChangesInfo}
          fieldChangesInfo={fieldChangesInfo}
          setFieldChangesInfo={setFieldChangesInfo}
          getFieldChanges={getFieldChanges}
          openLastChanges={openLastChanges}
          profileName={profileName}
          setProfileName={setProfileName}
          sessionNoLongerExists={sessionNoLongerExists}
          setSessionNoLongerExists={setSessionNoLongerExists}
          publicIP={publicIP}
          setOpenByProfileModal={setOpenByProfileModal}
          getTracksListCbx={getTracksListCbx}
          tracksListCbx={tracksListCbx}
        />
      )}

      <LimitsModal
        data={data}
        profiles={profiles}
        trackCategory={trackCategory}
        limitSetList={limitSetList}
        idLimitSet={idLimitSet}
        setIdLimitSet={setIdLimitSet}
        limitSetBetTypes={limitSetBetTypes}
        setLimitSetBetTypes={setLimitSetBetTypes}
        setProfileOptionSelected={setProfileOptionSelected}
        profileOptionSelected={profileOptionSelected}
        setCategoryOptionSelected={setCategoryOptionSelected}
        categoryOptionSelected={categoryOptionSelected}
        limitSetInfo={limitSetInfo}
        setLimitSetInfo={setLimitSetInfo}
        getProfiles={getProfiles}
        getTrackCategory={getTrackCategory}
        getLimitSetList={getLimitSetList}
        getLimitSetID={getLimitSetID}
        betTypeOptionSelected={betTypeOptionSelected}
        setBetTypeOptionSelected={setBetTypeOptionSelected}
        lastChanges={lastChanges}
        setLastChanges={setLastChanges}
        setGetLastChangesInfo={setGetLastChangesInfo}
        lastChangesInfo={lastChangesInfo}
        setLastChangesInfo={setLastChangesInfo}
        fieldChangesInfo={fieldChangesInfo}
        setFieldChangesInfo={setFieldChangesInfo}
        getFieldChanges={getFieldChanges}
        openLastChanges={openLastChanges}
        profileName={profileName}
        setProfileName={setProfileName}
        categoryName={categoryName}
        setCategoryName={setCategoryName}
        betTypeName={betTypeName}
        setBetTypeName={setBetTypeName}
        sessionNoLongerExists={sessionNoLongerExists}
        setSessionNoLongerExists={setSessionNoLongerExists}
        publicIP={publicIP}
      />

      <SystemPreferencesModal
        data={data}
        systemPreferences={systemPreferences}
        setSystemPreferences={setSystemPreferences}
        sessionNoLongerExists={sessionNoLongerExists}
        setSessionNoLongerExists={setSessionNoLongerExists}
      />

      {isPastPostTicketsModalOpen && (
        <PossiblePastPostModal
          datePastPostFilter={datePastPostFilter}
          setDatePastPostFilter={setDatePastPostFilter}
          pastPostTicketsByDate={pastPostTicketsByDate}
          setPastPostTicketsByDate={setPastPostTicketsByDate}
          getPastPostTicketsByDate={getPastPostTicketsByDate}
          selectedTicketsVoidScore={selectedTicketsVoidScore}
          setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
          scoreTickets={scoreTickets}
          selectAllTickets={selectAllTickets}
          setSelectAllTickets={setSelectAllTickets}
          voidTickets={voidTickets}
          callTicketVoidListFrom={callTicketVoidListFrom}
          isPastPostTicketsModalOpen={isPastPostTicketsModalOpen}
          setIsPastPostTicketsModalOpen={setIsPastPostTicketsModalOpen}
          userRightsList={userRightsList}
        />
      )}

      <ManuallyScoreTicketsModal
        manuallyScoreTickets={manuallyScoreTickets}
        getManuallyScoreTickets={getManuallyScoreTickets}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        scoreTickets={scoreTickets}
      />

      <PayRebatesModal data={data} />

      {openNewRaceModal && (
        <NewRaceModal
          gameProviders={gameProviders}
          setSelectedProvider={setSelectedProvider}
          selectedProvider={selectedProvider}
          userInfo={data}
          setRefreshInfo={setRefreshInfo}
          refreshInfo={refreshInfo}
          setRefreshEntries={setRefreshEntries}
          refreshEntries={refreshEntries}
          setSelectOption={setSelectOption}
          getActiveTracks={getActiveTracks}
          setSessionNoLongerExists={setSessionNoLongerExists}
          setOpenNewRaceModal={setOpenNewRaceModal}
          getTracksListCbx={getTracksListCbx}
          tracksListCbx={tracksListCbx}
        />
      )}

      <OpenTicketsModal
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        dateFromOpenTickets={dateFromOpenTickets}
        setDateFromOpenTickets={setDateFromOpenTickets}
        dateToOpenTickets={dateToOpenTickets}
        setDateToOpenTickets={setDateToOpenTickets}
        getOpenTicketsByPeriodOffTime={getOpenTicketsByPeriodOffTime}
        openTicketsByPeriodOffTime={openTicketsByPeriodOffTime}
        setOpenTicketsByPeriodOffTime={setOpenTicketsByPeriodOffTime}
        callTicketVoidListFrom={callTicketVoidListFrom}
        scoreTickets={scoreTickets}
        voidTickets={voidTickets}
        userRightsList={userRightsList}
      />
      {showPackagesModal && (
        <MyPackagesModal
          show={showPackagesModal}
          onClose={() => setShowPackagesModal(false)}
          setHasUpgrade={setHasUpgrade}
          data={data}
          setSessionNoLongerExists={setSessionNoLongerExists}
          systemPreferences={systemPreferences}
          setSystemPreferences={setSystemPreferences}
        />
      )}

      <header className="navbar pcoded-header navbar-expand-lg navbar-dark bg-dark headerpos-fixed">
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav mr-auto" style={{ cursor: "pointer" }}>
            {hasTrackPermissions() && (
              <li className="nav-item dropdown">
                <span
                  className="dropdown-toggle"
                  href="#"
                  data-toggle="dropdown"
                >
                  Tracks
                </span>
                <ul className="dropdown-menu">
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_TRACKS,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#trackListModal"
                      onClick={() => getTracks()}
                    >
                      <span className="dropdown-item">List</span>
                    </li>
                  )}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_TRACK_CATEGORY,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#trackCategoryModal"
                      onClick={() => getTrackCategory()}
                    >
                      <span className="dropdown-item">Category</span>
                    </li>
                  )}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_TRACK_CATEGORY,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#altCategoryModal"
                      onClick={openAltCategoryModal}
                    >
                      <span className="dropdown-item">Alternate Category</span>
                    </li>
                  )}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_TRACKS_BY_BOOK,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#trackByBookModal"
                      onClick={openByBookModal}
                    >
                      <span className="dropdown-item">By Book</span>
                    </li>
                  )}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_PROFILE_TRACKS,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#trackByProfileModal"
                      onClick={openByProfilesModal}
                    >
                      <span className="dropdown-item">By Profiles</span>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {userRightsList.find(
              (right) => right.FormName === Rights.FRM_NEW_RACES,
            ) && (
              <li
                className="nav-item dropdown"
                data-toggle="modal"
                data-target="#newRaceModal"
                onClick={() => setOpenNewRaceModal(true)}
              >
                <span className="">Race</span>
              </li>
            )}
            {userRightsList.find(
              (right) => right.FormName === Rights.FRM_LIMITS,
            ) && (
              <li
                className="nav-item dropdown"
                data-toggle="modal"
                data-target="#limitsModal"
                onClick={openLimitsModal}
              >
                <span className="">Limits</span>
              </li>
            )}
            {hasTicketsPermissions() && (
              <li className="nav-item dropdown">
                <span
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  style={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Tickets
                </span>
                <ul className="dropdown-menu">
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_PAST_POST,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#possiblePastPostModal"
                      onClick={() => {
                        setIsPastPostTicketsModalOpen(true);
                      }}
                    >
                      <span className="dropdown-item">Past Post Tickets</span>
                    </li>
                  )}
                  {/* <li
                  data-toggle="modal"
                  data-target="#manuallyScoreTicketsModal"
                  onClick={() => getManuallyScoreTickets()}
                >
                  <a className="dropdown-item" href="#">
                    Manually Score Tickets
                  </a>
                </li> */}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_OPEN_TICKETS,
                  ) && (
                    <li
                      data-toggle="modal"
                      data-target="#openTicketsModal"
                      onClick={() => getOpenTicketsByPeriodOffTime(false)}
                    >
                      <span className="dropdown-item">Open Tickets</span>
                    </li>
                  )}
                  {userRightsList.find(
                    (right) => right.FormName === Rights.FRM_PAY_REBATES,
                  ) && (
                    <li data-toggle="modal" data-target="#payRebatesModal">
                      <span className="dropdown-item">Pay Rebates</span>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {userRightsList.find(
              (right) => right.FormName === Rights.FRM_PREFERENCES_RACING,
            ) && (
              <li
                className="nav-item dropdown"
                data-toggle="modal"
                data-target="#systemPreferencesModal"
                onClick={handleGetSystemPreferencesRacing}
              >
                <span className="">Maintenance</span>
              </li>
            )}
          </ul>
          <ul className="navbar-nav ml-auto mr-4">
            {systemPreferences.UpgradeEnabled && (
              <>
                <MDBTooltip
                  tag="i"
                  wrapperProps={{ href: "#" }}
                  title="My Packages"
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    onClick={() => {
                      setShowPackagesModal(true);
                      localStorage.setItem(
                        "packagesModalOpenedDate",
                        new Date().toDateString(),
                      );

                      setHasUpgrade(false);
                    }}
                  >
                    <i
                      className="fas fa-cogs mr-1"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    ></i>
                    {hasUpgrade && (
                      <div className="warning-container">
                        <span style={{ color: "#000" }}>!</span>
                      </div>
                    )}
                  </div>
                </MDBTooltip>
              </>
            )}
            <li className="dropdown drp-user pr-0">
              <a
                className="mr-2"
                href="#nolink"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  className="fas fa-user-circle"
                  style={{ color: "#ffffff", fontSize: "23px" }}
                />
              </a>
              <div
                className="dropdown-menu dropdown-menu-right profile-notification "
                style={{ borderRadius: "20px" }}
              >
                <div
                  className="pro-head"
                  style={{ textAlign: "center", height: "50px" }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {localStorage.getItem("userName")}
                  </span>
                </div>
                <ul className="pro-body">
                  <li>
                    <span className="dropdown-item" onClick={() => logout()}>
                      <i className="fas fa-sign-out-alt fa-bold"></i> Logout
                    </span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
